<div class="app-toast-container-wrapper">
  @for (toast of toastService.queue(); track toast.id) {
    <div
      (click)="toastService.remove(toast.id)"
      (mouseenter)="toastService.pauseTimer(toast.id)"
      (mouseleave)="toastService.startTimer(toast.id, toast.duration)"
      class="app-toast-container-toast hw-border"
      [class]="toast.color"
    >
      <span class="typ-toast">{{ toast.message }}</span>

      <div class="flex items-center gap-hw-xsmall">
        @for (action of toast.actions; track action.label) {
          <app-button
            [label]="action.label"
            [color]="action.color"
            (click)="action.callback()"
          ></app-button>
        }
      </div>

      @if (toast.timerId) {
        <div
          class="app-toast-container-fuse"
          [class]="toast.color"
          [style.animation-duration.ms]="toast.duration"
          [style.animation-play-state]="'running'"
        ></div>
      }
    </div>
  }
</div>
